import { defineStore } from "pinia";

export type ToastItem = {
  id: number;
  message: string;
  type: "success" | "error";
  code?: string;
  status?: number;
};

export type ToastMeta = Pick<ToastItem, "code" | "status">;

export const useToastStore = defineStore("toast", {
  state: () => ({ items: [] as ToastItem[] }),
  actions: {
    push(message: string, type: "success" | "error" = "success", meta: ToastMeta = {}) {
      const id = Date.now() + Math.random();
      this.items.push({ id, message, type, ...meta });
      window.setTimeout(() => this.remove(id), 3000);
    },
    remove(id: number) {
      this.items = this.items.filter((item) => item.id !== id);
    }
  }
});
